var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8354 5.09106V10.0002",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0868 12.4545L10.8354 10",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09091 7.10775H1V3.01685",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47125 16.364C5.72992 17.6226 7.33357 18.4798 9.0794 18.8271C10.8252 19.1743 12.6348 18.9961 14.2794 18.3149C15.9239 17.6337 17.3295 16.4802 18.3184 15.0001C19.3074 13.5201 19.8352 11.78 19.8352 10C19.8352 8.21997 19.3074 6.47991 18.3184 4.99987C17.3295 3.51983 15.9239 2.36628 14.2794 1.68509C12.6348 1.0039 10.8252 0.82567 9.0794 1.17294C7.33357 1.5202 5.72992 2.37737 4.47125 3.63604L1 7.10729",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshTime);
export default __webpack_public_path__ + "static/media/refresh-time.7615ac81cf49b341c0a08349d49a6fc0.svg";
export { ForwardRef as ReactComponent };